import { render, staticRenderFns } from "./LicensingServices.vue?vue&type=template&id=10e46b95&"
import script from "./LicensingServices.vue?vue&type=script&lang=js&"
export * from "./LicensingServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports